import controller from '../controller/controller';

/**
 * Инструмент «Инструкция» в ЛК: открытие окна с текстом подсказки.
 *
 * Своей модалки не заводим — используем общий стек окон (v-modal + v-modal-window),
 * поэтому бесплатно получаем крестик, закрытие по Esc, клик по затемнению и
 * корректную работу с историей браузера.
 *
 * Данные приходят из PHP (getInstructionData() в tools.php):
 * {code, title, buttonText, html, autoOpen}.
 */
export function openInstruction(data) {
	if (!data || !data.html) {
		return;
	}

	controller.openModal({
		className: 'modal--instruction',
		component: {
			name: 'v-instruction-content',
			props: {
				title: data.title || '',
				html: data.html
			}
		}
	});
}

/**
 * Автопоказ при первом заходе на страницу. Решение принимает сервер
 * (флаг autoOpen), здесь только небольшая задержка: window.modalController
 * появляется в хуке created компонента v-modal из шапки страницы.
 */
export function autoOpenInstruction(data) {
	if (!data || !data.autoOpen) {
		return;
	}

	setTimeout(() => openInstruction(data), 300);
}
